

















































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import Snackbar from '@/components/shared/Snackbar.vue';
import { IDossierOutboundNoticeOfLoss } from '@/store/models/IDossierOutboundNoticeOfLoss';

@Component({ components: { Snackbar } })
export default class DossierOutboundsNoticeOfLoss extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;

  dossierApi = new DossierApi();
  groupedNotices: any[] = [];
  expanded: any[] = [];
  loadingNotices = false;

  // Cabeceras principales
  noticeHeaders = [
      { text: 'Warehouse', value: 'warehouse' },
      { text: 'Date', value: 'date' },
      { text: 'Total Goods Lost', value: 'totalGoods' }
  ];

  // Cabeceras del detalle
  noticeDetailHeaders = [
      { text: 'Pallet Type', value: 'palletType' },
      { text: 'Pallet Id', value: 'idPallet' },
      { text: 'Cases/Pallet', value: 'casesPerPallet' },
      { text: 'Goods/Case', value: 'goodsPerCase' },
      { text: 'Total Goods Lost', value: 'totalGoods' }
  ];

  async mounted() {
      await this.loadOutboundsNoticeOfLoss();
  }

  /** 🔹 Carga los registros y agrupa por idNoticeOfLoss */
  async loadOutboundsNoticeOfLoss() {
      if (!this.inboundCode) return;
      this.loadingNotices = true;

      try {
          const data: IDossierOutboundNoticeOfLoss[] =
        await this.dossierApi.DossierReadOutboundsNoticeOfLoss(this.inboundCode);
          // Agrupamos por idNoticeOfLoss
          this.groupedNotices = Object.values(
              data.reduce((acc: any, curr: IDossierOutboundNoticeOfLoss) => {
                  const key = curr.idNoticeOfLoss || curr.id;

                  if (!acc[key]) {
                      acc[key] = {
                          rowKey: key,
                          idNoticeOfLoss: curr.idNoticeOfLoss,
                          idDeliveryNote: curr.idDeliveryNote,
                          warehouse: curr.warehouse,
                          date: curr.date,
                          totalGoods: 0,
                          details: [] as any[]
                      };
                  }

                  acc[key].details.push({
                      palletType: curr.palletType,
                      idPallet: curr.idPallet,
                      casesPerPallet: curr.casesPerPallet,
                      goodsPerCase: curr.goodsPerCase,
                      totalGoods: curr.totalGoods
                  });

                  acc[key].totalGoods += curr.totalGoods || 0;

                  return acc;
              }, {})
          );

          console.log('📦 Grouped Outbounds Notice of Loss:', this.groupedNotices);
      } catch (err) {
          console.error('❌ Error loading Outbounds Notice of Loss:', err);
      } finally {
          this.loadingNotices = false;
      }
  }

  formatDate(date: Date | null) {
      if (!date) return '';
      return new Date(date).toLocaleDateString();
  }
}
